import styled from 'styled-components'

export const SubmitButton = styled.button`
    margin-top: 1em;
    color: #fff;
    background-color: #C36500;
    border-radius: 17px;
    padding: 12px;
    border: none;
    font-weight: bold;
    user-select: none;
    display: block;
    width: 60%;
    box-shadow: 0px 3px 6px #00000029;

    &:hover{
        background-color: #A95700;
        cursor: pointer;
    }

    &:disabled{
        background-color: #D3D3D3;
        cursor: default;
    }
`

export const SecondaryButton = styled.button`
    margin-top: 1em;
    color: #000;
    background-color: #fff;
    border-radius: 17px;
    padding: 12px;
    border: 1px solid #444242;
    font-weight: bold;
    user-select: none;
    display: block;
    width: 100%;
    box-shadow: 0px 3px 6px #00000029;

    &:hover{
        background-color: #DDD;
    }
`

export const Title = styled.label`
    font-weight: bold;
    font-size: 1.5em;
`

export const Subtitle = styled.label`
    font-weight: bold;
    color: #444242;
    font-size: 1.25em;
`

export const TextLabel = styled.label`
    color: #444242;
    font-size: 1.25em;
`

export const Container = styled.div`
    background-color: #fff;
    padding: 24px 24px 14px 24px;
    border-radius: 23px;
    margin: 0 auto;
    height: fit-content;
    border: 1px solid #9A999E;
    box-shadow: 0px 3px 6px #00000029;

    @media only screen and (max-width : 419px) {
        width: 95vw;
    }

    /* Smartphone */
    @media only screen and (min-width : 420px) and (max-width : 767px) {
        width: 90vw;
    }
    
    /* Tablet */ 
    @media only screen and (min-width : 768px) and (max-width : 1023px) {
        width: 60vw;
        margin-top: 5%;
    }
    
    /* Desktop */
    @media only screen and (min-width : 1024px) {
        width: 40vw;
        margin-top: 5%;
    }

    @media only screen and (min-width : 1440px) {
        width: 40vw;
        margin-top: 3.5%;
    }

    /* TV */
    @media only screen and (min-width : 2460px) {
        width: 20vw;
        margin-top: 5%;
    }

    input:focus {
        outline: none;
    } 
`

export const DivTextAlignCenter = styled.div`
    text-align: center;
    display: block;
`

export const ImageHeader = styled.img`
    user-select: none;
    text-align: -webkit-center;

    /* Smartphone */
    @media only screen and (max-width : 767px) {
            width: 50vw;
        }
    
    /* Tablet */ 
    @media only screen and (min-width : 768px) and (max-width : 1023px) {
        width: 30vw;
    }
    
    /* Desktop */
    @media only screen and (min-width : 1024px) {
        width: 15vw;
    }

    /* TV */
    @media only screen and (min-width : 2460px) {
        width: 8vw;
    }
`

export const ImageReceipt = styled.img`
    user-select: none;
    text-align: -webkit-center;
    float: right;

    /* Smartphone */
    @media only screen and (max-width : 767px) {
            width: 20vw;
        }
    
    /* Tablet */ 
    @media only screen and (min-width : 768px) and (max-width : 1023px) {
        width: 20vw;
    }
    
    /* Desktop */
    @media only screen and (min-width : 1024px) {
        width: 10vw;
    }

    /* TV */
    @media only screen and (min-width : 2460px) {
        width: 8vw;
    }
`

export const CircleButton = styled.button`
    color: #FFF;
    background-color: #C36500;
    border-radius: 50%;
    border: none;
    font-weight: bold;
    user-select: none;
    display: block;
    box-shadow: 0px 3px 6px #00000029;

    &:hover{
        filter: brightness(90%);
    }

    &:focus{
        outline: none !important;
        border: none !important;
    }
`

export const BackButton = styled.button`
    &:focus{
        outline: none !important;
        border: 0;
        box-shadow: none !important;
    }
    &:hover{
        filter: brightness(90%);
    }
`

export const ButtonDiv = styled.button`
    background-color: #fff;
    padding: 25px;
    border-radius: 23px;
    margin-top: 25px;
    height: fit-content;
    border: 1px solid #9A999E;
    box-shadow: 0px 3px 6px #00000029;
    width: 100%;

    &:focus {
        outline: none;
    } 
    &:hover{
        filter: brightness(95%);
    }
`

export const DivFlexCenter = styled.div`
    display: flex;
    justify-content: center; 
    align-items: center;
`

export const DivCenter = styled.div`
    display: block;
    flex-direction: column;
`

export const ContainerCenter = styled.div`
    margin: 0 auto;
    height: fit-content;

    @media only screen and (max-width : 419px) {
        width: 100vw;
    }

    /* Smartphone */
    @media only screen and (min-width : 420px) and (max-width : 767px) {
        width: 80vw;
    }
    
    /* Tablet */ 
    @media only screen and (min-width : 768px) and (max-width : 1023px) {
        width: 60vw;
    }
    
    /* Desktop */
    @media only screen and (min-width : 1024px) {
        width: 40vw;
    }

    @media only screen and (min-width : 1440px) {
        width: 40vw;
    }

    /* TV */
    @media only screen and (min-width : 2460px) {
        width: 20vw;
    }

    input:focus {
        outline: none;
    }
`

export const DivFlexStart = styled.div`
    display: flex;
    justify-content: start; 
    align-items: start;
`

export const DivFlexEnd = styled.div`
    display: flex;
    justify-content: end; 
    align-items: end;
`

export const BackDiv = styled.div`
    margin: 0 auto;

    @media only screen and (max-width : 419px) {
        width: 100vw;
    }

    /* Smartphone */
    @media only screen and (min-width : 420px) and (max-width : 767px) {
        width: 80vw;
    }
    
    /* Tablet */ 
    @media only screen and (min-width : 768px) and (max-width : 1023px) {
        width: 60vw;
    }
    
    /* Desktop */
    @media only screen and (min-width : 1024px) {
        width: 40vw;
    }

    @media only screen and (min-width : 1440px) {
        width: 40vw;
    }

    /* TV */
    @media only screen and (min-width : 2460px) {
        width: 20vw;
    }
`

export const ImagePaymentType = styled.img`
    width: 100px;

    @media only screen and (max-width : 419px) {
        width: 80px;
    }

    /* Smartphone */
    @media only screen and (min-width : 420px) and (max-width : 767px) {
        width: 90px;
    }
`

export const ImageTimeout = styled.img`
    background-color: #fff;
    margin: 0 auto;
    width: 200px;
    heigth: 200px;
`

export const LabelPaymentType = styled.label`
    font-weight: bold;
    font-size: 2.5em;
    vertical-align: middle;
    margin-left: 25px;

    @media only screen and (max-width : 419px) {
        font-size: 1.7em;
    }

    /* Smartphone */
    @media only screen and (min-width : 420px) and (max-width : 767px) {
        font-size: 1.9em;
    }

    &:hover{
        cursor: pointer;
    }
`

export const DivLogo = styled.div`
    background-color: #fff;
    display: flex;
    justify-content: center; 
    align-items: center;
    width: fit-content;
    margin: 0 auto;
    padding: 8px;
    border-radius: 9px;
    border: 1px solid #9A999E;
    box-shadow: 0px 3px 6px #00000029;
`

export const DivQRCode = styled.div`
    background-color: #fff;
    margin: 0 auto;
    width: fit-content;
    height: fit-content;

    padding: 14px;
    border-radius: 18px;
    box-shadow: 0px 3px 6px #00000060;
`

export const IconLeft = styled.i`
  float: left;
  margin-left: 10px;
  margin-top: -30px;
  position: relative;
  color: gray;
`

export const IconRight = styled.i`
  float: right;
  margin-right: 10px;
  margin-top: -40px;
  position: relative;
  max-width: 1.25em;
  font-size: 1.25em;

  &:hover{
    cursor: pointer;
    color: #606060;
  }
`

export const CopyPaste = styled.div`
    resize: none;
    background-color: #FFF !important;
    line-height: 1.5em !important;
    color: #CE6B00;
    font-size: 20px;
    border: none;
    width: 95%;
    
    overflow: hidden;
    white-space: nowrap !important;
    text-overflow: ellipsis;
    user-select: none;
`

export const CopyPasteDiv = styled.div`
    border: 3px solid #CE6B00;
    border-radius: 23px;
    overflow: hidden;
    width: 100%;
`

